<template>
  <patient-search
    v-model="selectedPatient"
    :disabled="isSDMStarted || isFollowUpStarted || isUnhandledMedication || isInvalidRoute"
  ></patient-search>
</template>

<script>
import { mapGetters } from 'vuex';
import PatientSearch from './PatientSearch'

/**
 * Component GeneralPatientSearch.vue
 *
 * @module GeneralPatientSearch
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Patient/GeneralPatientSearch.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'GeneralPatientSearch',
  components: {
    PatientSearch,
  },
  computed: {
    ...mapGetters({
      isSDMStarted: 'followupSession/isSDMStarted',
      isFollowUpStarted: 'followupSession/isFollowUpStarted',
      unhandledMedication: 'dss/unhandledMedicationRecommendations'
    }),
    isUnhandledMedication() {
      const dssRoutes = [
        'DSSCardioMedication',
        'DSSOtherMedication',
        'DSSSideEffectsAndAllergies',
        'DSSTitrationSchemes',
        'DSSAlgorithmInputs'
      ]

      return !!(dssRoutes.includes(this.$route.name) && this.unhandledMedication.length)
    },
    selectedPatient: {
      get() {
        return this.$store.getters['patientList/selectedPatient'];
      },
      set(patient) {
        if (!patient || !patient.patientId) return;

        this.$store.dispatch('patientList/selectPatient', patient);
        this.goToPatientOverview(patient);
      },
    },
    isInvalidRoute() {
      const invalidRoutes = ['Settings', 'About'];
      return invalidRoutes.includes(this.$route.name)
    }
  },
  methods: {
    goToPatientOverview(patient) {
      const { name, params } = this.$route;
      const idMatch = patient.patientId === params.patientId;

      if (name === 'PatientOverview' && idMatch) return;

      this.$router.push({
        name: 'PatientOverview',
        params: { patientId: patient.patientId },
      });
    },
  },
  created() {
    const { params } = this.$route;
    const selectedPatient = this.$store.getters['patientList/selectedPatient'];

    if (params.patientId && params.patientId !== selectedPatient.patientId) {
      const patient = {
        text: this.$store.getters['patientSummary/searchText'],
        patientId: this.$store.getters['patientSummary/id'],
      };

      if (patient) {
        this.$store.dispatch('patientList/selectPatient', patient);
      }
    } else if (!params.patientId && selectedPatient.patientId) {
      this.$store.dispatch('patientList/reset');
    }
  },
};
</script>
